// @flow
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { Small } from '@finect/tabular-core/Small';
import { Hero, HeroContent, HeroText, HeroCTA } from './partials';
import heroMortgages from './assets/heroMortgages.webp';
import heroMortgagesTablet from './assets/heroMortgages-tablet.webp';
import heroMortgagesMobile from './assets/heroMortgages-mobile.webp';

type Props = {
  toggleModal: Function
};

export const HeroMortgages = ({ toggleModal }: Props) => (
  <Hero>
    <picture>
      <source media="(max-width: 500px)" srcSet={heroMortgagesMobile} type="image/webp" />
      <source media="(max-width: 900px)" srcSet={heroMortgagesTablet} type="image/webp" />
      {/* Imagen LCP: eager (NO lazy, está en el viewport inicial) + fetchpriority alta */}
      <img
        className="hero-bg"
        src={heroMortgages}
        alt="Familia colocando cajas de mudanza en su nueva casa"
        // eslint-disable-next-line react/no-unknown-property
        fetchpriority="high"
        decoding="async"
      />
    </picture>
    <HeroContent>
      <HeroText>
        <h1>Encuentra la mejor hipoteca en solo 2 minutos</h1>
        <p>
          Compara ofertas reales de los principales bancos en menos de 2 minutos. Sin comisiones, sin llamadas. 100%
          online y gratuito.
        </p>
        <br />
        <p>Simula tu hipoteca y elige la opción que más te convenga para empezar tu nueva vida.</p>
      </HeroText>
      <HeroCTA>
        <Small display="block" textAlign="center" margin="0 0 6px">
          Esta búsqueda es 100% gratuita
        </Small>
        <Button secondary onClick={() => toggleModal()}>
          Calcula mi hipoteca
        </Button>
      </HeroCTA>
    </HeroContent>
  </Hero>
);
